<script setup>
import { inject, ref, watch, nextTick, onMounted } from 'vue';
import PatologiaForm from './PatologiaForm.vue';
import ModalSimple from '../ModalSimple.vue';
import { confirmarEliminar } from '@/libs/cifra/dialogs';

const $I18n = inject('I18n');
const { t } = $I18n;

const props = defineProps({
  titulo: { type: String, default: null },
  patologias: { type: Array, required: true },
  inputName: { type: String, default: undefined },
  disabled: { type: Boolean, default: false }
});

const emit = defineEmits(['refresh', 'borrar']);

const selectedPatologia = ref(null);
const mostrarModal = ref(false)
const localPatologias = ref([...props.patologias]);

watch(() => props.patologias, (val) => {
  localPatologias.value = [...val];
});

function openForm(patologia = null) {
  selectedPatologia.value = patologia || {};
  mostrarModal.value = true;
}
function closeForm() {
  mostrarModal.value = false;
  selectedPatologia.value = null;
}
function onSaved(newPatologia) {
  // Si es edición, reemplaza; si es nuevo, añade
  if (newPatologia.id) {
    const idx = localPatologias.value.findIndex(p => p.id === newPatologia.id);
    if (idx !== -1) {
      localPatologias.value[idx] = newPatologia;
    } else {
      localPatologias.value.push(newPatologia);
    }
  } else {
    // Genera un id temporal si no existe
    newPatologia.id = Date.now();
    localPatologias.value.push(newPatologia);
  }
  closeForm();
}
function borrarPatologia(patologia) {
  confirmarEliminar().then(() => {
    // Elimina la patología de la lista local
    localPatologias.value = localPatologias.value.filter(p => p.id !== patologia.id);
    emit('borrar', patologia);
  });
}
function formatDate(date) {
  if (!date) return '';
  return new Date(date).toLocaleDateString();
}

onMounted(() => {
  // Cierra el modal si se cierra por fuera (ej: click fondo)
  if (window.$ && $('#patologiaModal').on) {
    $('#patologiaModal').on('hidden.bs.modal', () => {
      selectedPatologia.value = null;
    });
  }
});
</script>

<template>
  <div>
    <div class="titulo-seccion ">
      <a
        v-if="!disabled"
        class="btn-sm btn btn-cifra pull-right"
        @click="openForm()"
      >
        <i class="far fa-plus"></i>
      </a>
      {{ titulo || t('Datos_salud') }}
    </div>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>{{ t('Tipo') }}</th>
            <th>{{ t('Descripcion') }}</th>
            <th>{{ t('Fecha_inicio') }}</th>
            <th>{{ t('Fecha_fin') }}</th>
            <th v-if="!disabled"></th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr v-for="patologia in localPatologias" :key="patologia.id">
            <td>{{ t(`activerecord.enums.patologia.tipo.${patologia.tipo}`) }}</td>
            <td>{{ patologia.descripcion }}</td>
            <td>{{ formatDate(patologia.fecha_inicio) }}</td>
            <td>{{ patologia.fecha_fin ? formatDate(patologia.fecha_fin) : '' }}</td>
            <td v-if="!disabled" class="acciones">
              <a @click.prevent="openForm(patologia)">
                <i class="fa fa-fw fa-edit"></i>
              </a>
              <a class="text-cifra" @click.prevent="borrarPatologia(patologia)">
                <i class="fa fa-fw fa-trash m-l-xs"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <input v-if="inputName" type="hidden" :name="inputName" :value="JSON.stringify(localPatologias)" />
    <ModalSimple
      v-if="!disabled"
      v-model="mostrarModal"
      id="patologiaModal"
      :titulo="t('Datos_salud')"
    >
      <PatologiaForm
        :patologia="selectedPatologia"
        @close="closeForm"
        @saved="onSaved"
      />
    </ModalSimple>
  </div>
</template>

